import { DropdownOption } from "@cms/shared-library"
import { FileUploadComponent } from "../components/file-upload/file-upload.component"
import { TrainingProgramAttestationSection } from "../models/tp-attestation-section.model"
import { TrainingProgramApplicationProcessInfoModel } from "../models/training-program-application-process-info.model"
import { TrainingProgramSearchVariablesModel } from "../models/training-program-search-variables-model.model "

export abstract class TrainingProgramApplicationUtils {

  static EmptyGuid = '00000000-0000-0000-0000-000000000000'

  static WAHFull = "9d17c877-c580-4370-9f5d-d0fb04b09ef1"
  static WAHRefresher = "1ec91659-d817-473a-8e52-c5a72b2f0696"
  static JHSC1 = "3e2f79fd-4dc3-45b5-875c-737921fcf71e"
  static JHSC2 = "6d534dd1-d001-4ad2-b7da-7e3880b15607"
  static JHSCR = "990fba34-05fb-4005-9f83-783d96b38dfb"

  static InClass = "8e2f4cd8-833b-4ee6-b71d-70074aa7b5cf"
  static Blended = "e15c8a24-14b5-4fc6-9ea4-9f1a95d5f810"
  static eLearning = "c5d83005-e948-469e-8695-bf656dd613bf"
  static Distance = "8244833c-8370-4ca4-8330-bff9bca5c51a"

  static ProgramAttestationGroup = 'ProgramAttestation'
  static ProviderAttestationGroup = 'ProviderAttestation'

  static DSA = 'F5915713-AC3D-4F96-8036-CC20413A7E16'
  static ASA = '967D4CED-A8E2-4DC7-A9F7-5129A830A2D6'
  static EmployerAdmin = 'dffd0336-c39e-4a86-bc8f-47fc9996c186'

  static trainingProgramSearchVariables = new Map<string, TrainingProgramSearchVariablesModel>();

  static CertWorkerTab = 1
  static ScheduleWorkerTab = 2
  static ContactUsTab = 4

  // Certificate Code
  static WAH_CERTCODE = 'WAH';
  static JHSC_CERTCODE = 'JHSC';
  static JHSC1996_CERTCODE = 'JHSC1996';

  //ROC
  static ROCAll = -2
  static ROCExpired = 0
  static ROCWAHValid = 1
  static ROCJHSCCertified = 2
  static ROCJHSCInProgress = 3
  static ROCNotValid = 4
  static ROCJHSCPreReqsNotMet = 5

  //exemption request decision status
  static ExemptionRequestApproved = 1
  static ExemptionRequestPending = 0
  static ExemptionRequestRejected = -1


  static timeOptions = [
    { value: '12:00 AM', order: 0 },
    { value: '12:15 AM', order: 15 },
    { value: '12:30 AM', order: 30 },
    { value: '12:45 AM', order: 45 },
    { value: '1:00 AM', order: 100 },
    { value: '1:15 AM', order: 115 },
    { value: '1:30 AM', order: 130 },
    { value: '1:45 AM', order: 145 },
    { value: '2:00 AM', order: 200 },
    { value: '2:15 AM', order: 215 },
    { value: '2:30 AM', order: 230 },
    { value: '2:45 AM', order: 245 },
    { value: '3:00 AM', order: 300 },
    { value: '3:15 AM', order: 315 },
    { value: '3:30 AM', order: 330 },
    { value: '3:45 AM', order: 345 },
    { value: '4:00 AM', order: 400 },
    { value: '4:15 AM', order: 415 },
    { value: '4:30 AM', order: 430 },
    { value: '4:45 AM', order: 445 },
    { value: '5:00 AM', order: 500 },
    { value: '5:15 AM', order: 515 },
    { value: '5:30 AM', order: 530 },
    { value: '5:45 AM', order: 545 },
    { value: '6:00 AM', order: 600 },
    { value: '6:15 AM', order: 615 },
    { value: '6:30 AM', order: 630 },
    { value: '6:45 AM', order: 645 },
    { value: '7:00 AM', order: 700 },
    { value: '7:15 AM', order: 715 },
    { value: '7:30 AM', order: 730 },
    { value: '7:45 AM', order: 745 },
    { value: '8:00 AM', order: 800 },
    { value: '8:15 AM', order: 815 },
    { value: '8:30 AM', order: 830 },
    { value: '8:45 AM', order: 845 },
    { value: '9:00 AM', order: 900 },
    { value: '9:15 AM', order: 915 },
    { value: '9:30 AM', order: 930 },
    { value: '9:45 AM', order: 945 },
    { value: '10:00 AM', order: 1000 },
    { value: '10:15 AM', order: 1015 },
    { value: '10:30 AM', order: 1030 },
    { value: '10:45 AM', order: 1045 },
    { value: '11:00 AM', order: 1100 },
    { value: '11:15 AM', order: 1115 },
    { value: '11:30 AM', order: 1130 },
    { value: '11:45 AM', order: 1145 },
    { value: '12:00 PM', order: 1200 },
    { value: '12:15 PM', order: 1215 },
    { value: '12:30 PM', order: 1230 },
    { value: '12:45 PM', order: 1245 },
    { value: '1:00 PM', order: 1300 },
    { value: '1:15 PM', order: 1315 },
    { value: '1:30 PM', order: 1330 },
    { value: '1:45 PM', order: 1345 },
    { value: '2:00 PM', order: 1400 },
    { value: '2:15 PM', order: 1415 },
    { value: '2:30 PM', order: 1430 },
    { value: '2:45 PM', order: 1445 },
    { value: '3:00 PM', order: 1500 },
    { value: '3:15 PM', order: 1515 },
    { value: '3:30 PM', order: 1530 },
    { value: '3:45 PM', order: 1545 },
    { value: '4:00 PM', order: 1600 },
    { value: '4:15 PM', order: 1615 },
    { value: '4:30 PM', order: 1630 },
    { value: '4:45 PM', order: 1645 },
    { value: '5:00 PM', order: 1700 },
    { value: '5:15 PM', order: 1715 },
    { value: '5:30 PM', order: 1730 },
    { value: '5:45 PM', order: 1745 },
    { value: '6:00 PM', order: 1800 },
    { value: '6:15 PM', order: 1815 },
    { value: '6:30 PM', order: 1830 },
    { value: '6:45 PM', order: 1845 },
    { value: '7:00 PM', order: 1900 },
    { value: '7:15 PM', order: 1915 },
    { value: '7:30 PM', order: 1930 },
    { value: '7:45 PM', order: 1945 },
    { value: '8:00 PM', order: 2000 },
    { value: '8:15 PM', order: 2015 },
    { value: '8:30 PM', order: 2030 },
    { value: '8:45 PM', order: 2045 },
    { value: '9:00 PM', order: 2100 },
    { value: '9:15 PM', order: 2115 },
    { value: '9:30 PM', order: 2130 },
    { value: '9:45 PM', order: 2145 },
    { value: '10:00 PM', order: 2200 },
    { value: '10:15 PM', order: 2215 },
    { value: '10:30 PM', order: 2230 },
    { value: '10:45 PM', order: 2245 },
    { value: '11:00 PM', order: 2300 },
    { value: '11:15 PM', order: 2315 },
    { value: '11:30 PM', order: 2330 },
    { value: '11:45 PM', order: 2345 },
    { value: '11:59 PM', order: 2359 }
  ]

  static NotSubmitted = 1
  static UnderReview = 2
  static CPOApproved = 3
  static TriageStarted = 6
  static DapIssued = 7
  static DAPResponded = 8
  static TriageCompleted = 9
  static DeskReviewStarted = 10
  static DeskDapIssued = 11
  static DeskDAPResponded = 12
  static DeskReviewCompleted = 13
  static FieldChecklistToBeCompleted = 14
  static FieldChecklistSubmitted = 15
  static FieldChecklistConcernIssued = 16
  static FieldChecklistAcknowledged = 17
  static FieldAssessmentScheduleRequested = 18
  static FieldAssessmentScheduleProposed = 19
  static FieldAssessmentScheduleAccepted = 20
  static FieldAssessmentScheduleProposedByTSA = 21
  static FieldAssessmentScheduleConfirmedByTP = 22
  static FieldVisitConductedByTSA = 23
  static FieldDapIssued = 24
  static FieldDAPResponded = 25

  static WithdrawnDuringTriage = 36
  static WithdrawnDuringDesk = 37
  static WithdrawnDuringField = 38
  static WithdrawnDuringRecommondation = 39
  static WithdrawnRequested = 40
  static WithdrawnApproved = 41
  static Revoked = 42
  static RejectedDuringTriage = 30
  static RejectedDuringDesk = 31
  static RejectedDuringField = 32
  static RejectedDuringRecommendation = 33
  static ProactiveChangesSubmitted = 51;
  static ProgramUpdatesSubmitted = 52;
  static ProgramUpdatesAcknowledged = 53;
  static TrainingDeliveryVisitStart = 60;
  static ProQAReviewInProgress = 61;
  static ProQADapIssued = 62;
  static ReviewInProgress = 63;
  static ProActiveFieldChecklistToBeCompleted = 64;
  static ProActiveFieldChecklistSubmitted = 65;
  static ProactivePrefieldChecklistAcknowledged = 66;
  static ProactivePrefieldChecklistConcernIssued = 67;
  static QAFieldVisitToBeScheduled = 68;
  static QAFieldVisitScheduleProposalSubmitted = 69;
  static ProactiveFieldAssessmentScheduled = 70;
  static ProactiveFieldAssessmentTSAProposed = 71;
  static ProactiveFieldAssessmentTPConfirmed = 72;
  static ProactiveFieldAssessmentConductedByTSA = 73;
  static DapIssuedForFieldAssessment = 75;
  static DapRespondedForFieldAssessment = 76;
  static DapResponsesAcknowledgedForFieldAssessment = 80;
  static ProactiveFieldRecommendationReportRevisedByTsa = 81;
  static ChangeRequestRejected = 100;
  static ChangeRequestApproved = 101;
  static DAPResponsesAcknowledged = 105;
  static ReactiveProgramQAStartedByComplaint = 111;
  static TrainingDeliveryChecklistSubmitted = 112;
  static TrainingProgramApproved = 109;
  static ChangeRequestLeadsToProgramRevoked = 110;
  //phase completion events
  static TriageCompletedId = "CA43AD9E-DA03-4F68-8974-9BED3E3F17C6"
  static DeskCompletedId = "D0863B93-F828-444D-9903-13708F75882D"
  static FieldChecklistToBeCompletedStatusId = 'EC743E66-8570-4F81-81C9-785AF2678C9E'
  static FieldAssessmentScheduleRequestedStatusId = '010F45F8-419A-4817-87F1-3F24AA0566FC'
  static FieldAssessmentCompletedId = 'B5CDC9B2-59C4-4522-BC5A-73ED69BAACCE'
  static RecommendationSubmittedToCPO = '86EF0342-060F-4924-B2F8-A99B18878F7F'
  static CPOApprovedId = '422B1C3E-75AD-49EB-9E08-279E6D0116A5'
  static ApprovedProgramWithdrawalRequestApprovedId = '5E60B154-C164-4F92-9ACC-135CA46119EA'
  static ProQAReviewInProgressId = 'A2AC9071-39E9-4060-B8CF-36F689F46682'
  static ProQADapIssuedId = 'D4256EF0-6F41-4ED8-9748-FE71E6FA84C9';
  static ReviewInProgressId = 'C2159B99-3092-4F62-8041-92A3668FA13F';
  static ProActiveFieldChecklistToBeCompletedStatusId = '7A6BBC06-1245-4709-9B8E-3884917F8146'
  static ProactiveFieldAssessmentTSAProposedId = 'CE6B3121-FAFF-495E-87DE-12D67266E998'
  static TrainingDeliveryChecklistSubmittedId = 'A8C0AC30-4D37-49F3-AC86-BB2D8A1C65C7'

  //Phases
  static TriagePhase = 1
  static DeskPhase = 2
  static PreFieldPhase = 3
  static RecommendationPhase = 4
  static ApprovedPhase = 5

  // SOSE Statuses:
  static SoseApproved = 4;
  static SoseInactive = 5;
  static SoseReviewCompleted = 3;
  static SoseIncomplete = 1;
  static SoseUnderReview = 2;

  //Course Statuses
  static Active = 1
  static Completed = 2
  static Cancelled = 0
  //Classes created by API
  static ApiUserName = 'API'

  //Pages
  static ApplicantInformation = 'ApplicantInformation'
  static ProgramRequirements = 'ProgramRequirements'
  static ProgramStandards = 'ProgramStandards'
  static ProviderStandards = 'ProviderStandards'
  static Attestations = 'Attestations'
  static ProgramDocuments = 'ProgramDocuments'

  //Sections
  static TrainingProviderAttestation = 'TrainingProviderAttestation'
  static TrainingProgramAttestation = 'TrainingProgramAttestation'
  static AttestationCertification = 'AttestationCertification'
  static ApplicationInfoSectionName = 'ApplicationInfo';
  static ProofOfMaterialPurchase = 'ProofOfMaterialPurchase'
  static ProgramDocumentsDesk = 'ProgramDocumentsDesk'
  static LessonPlan = 'LessonPlan'
  static InstructorManual = 'InstructorManual'
  static PresentationMaterial = 'PresentationMaterial'
  static ParticipantManual = 'ParticipantManual'
  static AssociateHandouts = 'AssociateHandouts'
  static QuickReferenceMaterial = 'QuickReferenceMaterial'
  static EquipmentList = 'EquipmentList'
  static LearnerEvaluationPlan = 'LearnerEvaluationPlan'
  static WrittenTestsAndAssements = 'WrittenTestsAndAssements'
  static QualityAssuranceAndContinuousImprovementsPlan = 'QualityAssuranceAndContinuousImprovementsPlan'
  static DetailedDesignDocument = 'DetailedDesignDocument'
  static StoryBoard = 'StoryBoard'
  static ELearningCourse = 'ELearningCourse'
  static ProofOfTrainingCompletionDocument = 'ProofOfTrainingCompletionDocument'

  static AdultLearningPrinciplesSection = 'AdultLearningPrinciples'
  static InstructorMatsLearnerMatsEvalMatsSection = 'InstructorMaterialsLearnerMaterialsEvaluationMaterials'
  static TrainingProgramMaterials = 'TrainingProgramMaterials'
  static TrainingProgramLearningOutcomes = 'TrainingProgramLearningOutcomes'
  static LearningEvaluationMethodsAndFinalAssessment = 'LearningEvaluationMethodsAndFinalAssessment'

  static ProofOfCompletionWAH = '0a7e691f-6cb0-4b85-9357-95f6f8fff6ee'
  static ProofOfCompletionJHSC = 'c5b09909-f21a-4a9d-a484-6bf7800f2680'
  static ProofCompletionToCPOEn = 'Providing proof of completion to the CPO'
  static ProofCompletionToCPOFr = 'Fournir une preuve d’achèvement au CPO'

  // SOSE Application Sections:
  static AuditorProofOfRegistration = 'AuditorProofOfRegistration';
  static CertificationAuditReport = 'CertificationAuditReport';
  static OhsmsCertificate = 'OhsmsCertificate';
  static Cor2020SapReport = 'Cor2020SapReport';
  static OhsmsCertificate2 = 'OhsmsCertificate2';
  static AppDecisionLetterOfRecognition = 'AppDecisionLetterOfRecognition';
  static AppDecisionSoseMaterials = 'AppDecisionSoseMaterials';


  // SOSE Application Statuses:
  static SoseApplicationStatusIncomplete = 1; //Incomplete
  static SoseAppSubmittedForMinistryReview = 2; //Under review
  static SoseAppReviewCompleted = 3; //Under review
  static SoseAppApprovedByMnistry = 4; //Active
  static SoseAppRejectedByMnistry = 5; //Inactive

  // SOSE Application Statuses IDs:
  static SoseApplicationStatusIncompleteId = 'D126C271-922B-4064-958B-BE1C44B02F8F'; //Incomplete
  static SoseAppSubmittedForMinistryReviewId = '5E435162-30F2-4CD8-977F-F532A19B8916'; //Under review
  static SoseAppSubmittedReviewCompletedId = 'C11AAAE8-2EAB-47E4-9836-18A0B7AB5F51'; //Under review
  static SoseAppApprovedByMnistryId = 'C5098042-9285-43EE-8081-0D3075DEB593'; //Active
  static SoseAppRejectedByMnistryId = 'ACE4BBDB-A69A-4E9A-8B40-ACBA0419DD00'; //Inactive

  //Person role string values
  static AffiliateInstructor = 'Affiliate instructor'
  static AlternateSigningAuthority = 'Alternate signing authority'
  static Administrator = 'Administrator'
  static Instructor = 'Instructor'
  static AffiliateAdministrator = 'Affiliate administrator'
  static DesignatedSigningAuthority = 'Designated signing authority'

  //Person role string values
  static AffiliateInstructorFr = 'Formateur affilié'
  static AlternateSigningAuthorityFr = 'Autre signataire autorisé'
  static AdministratorFr = 'Administrateur'
  static InstructorFr = 'Formateur'
  static AffiliateAdministratorFr = 'Administrateur affilié'
  static DesignatedSigningAuthorityFr = 'Signataire autorisé désigné '

  //Person role IDs
  static AffiliateInstructorId = 'CC21807F-835F-4DE0-AEB1-140C98DD5638'
  static AlternateSigningAuthorityId = '967D4CED-A8E2-4DC7-A9F7-5129A830A2D6'
  static AdministratorId = '4E345551-61B5-4E52-B682-5FD52B7BDBBA'
  static InstructorId = 'EC908DA6-376C-4F46-B889-8C25EAC5A75C'
  static AffiliateAdministratorId = '70580483-EC28-4CB5-9393-BE4DE72A6C85'
  static DesignatedSigningAuthorityId = 'F5915713-AC3D-4F96-8036-CC20413A7E16'
  static WorkerRoleName = 'WORKER'

  //Notification type IDs (from lookup table)
  static ClassroomNotification = '124CD268-5122-4EC6-9882-90DFFBBD223E'
  static MyLearnersNotification = '21D18290-5C91-492A-8592-0CC8DEAB594C'
  static MyTeamNotification = '4F63FD47-021B-43E9-A5C7-E781999501A8'
  static MinistryNotification = 'EC908DA6-376C-4F46-B889-8C25EAC5A75C'
  static ManualNotification = '51C251D2-4175-4830-8246-FD934E3353EB'

  //Decision Option Id
  static ApprovalDecisionOptionIdJHSC = '1275409A-BB81-40C6-A874-F53676AB7EF7'
  static ApprovalDecisionOptionIdWAH = '1B6AE71F-043E-44A5-AADC-169452CBF368'
  static WithdrawalDecisionOptionId = 'FD96AAB2-98D4-4290-9592-0BD261BD264B'

  //Director Name
  static DirectorName = 'E4A113FC-D32F-441B-9D19-171BB8272F63'

  //Notification Categories
  static Classroom = 'Classroom'
  static MyLearner = 'My learners'
  static MyTeam = 'My team'
  static Ministry = 'Ministry'
  static TrainingProvider = 'Training provider'
  static Manual = 'Manual'
  static ClassroomFr = 'Salle de classe'
  static MyLearnerFr = 'Mes apprenants'
  static MyTeamFr = 'Mon équipe'
  static MinistryFr = 'Ministère'
  static TrainingProviderFr = 'Fournisseur de services de formation '
  static ManualFr = 'Manuel'

  //Program Strings
  static JHSCPartOneStr = 'JHSC - Part One'
  static JHSCPartTwoStr = 'JHSC - Part Two'
  static JHSCRefresherStr = 'JHSC - Refresher'
  static JHSC1996PartOneStr = 'JHSC - 1996 Part Two'
  static JHSC1996PartTwoStr = 'JHSC - 1996 Part One'
  static WAHFullStr = 'Working at Heights - Full'
  static WAHRefresherStr = 'Working at Heights - Refresher'
  static EnglishStr = 'English'
  static FrenchStr = 'French'
  static InPersonStr = 'In-person'
  static BlendedStr = 'Blended'
  static ELearningStr = 'eLearning'
  static DistanceLearningStr = 'Distance learning'

  //User type
  static UserTypeTrainingProvider = 'Training Provider';
  static UserTypeLearner = 'Learner';
  static UserTypeEmployer = 'Employer';

  //Support Emails
  static JHSCInquiry = 'JhscInquiryLine'
  static WAHInquiry = 'WahInquiryLine'
  static GeneralInqiry = 'PreventionFeedback'
  static LegislationInquiry = 'WebOhs'
  static MissingLearnerRecord = 'MissingLearnerRecord'

  // Feature Flags
  static JhscRefresherOneTimeExemptionDisabledFf = 'JhscRefresherOneTimeExemptionDisabled';

  //Query string names
  static QueryStringDisplayFtuMessage = 'DisplayFtuMessage';

  //Approved Application Attestation edit
  static isAttestationSelected = false;
  static isAttestationEdit = false;
  static isAnswerChanged = false;
  static isFileUploaded = false;
  static HasPendingChangeRequest = false;

  //OHSMS Type Options
  static ohsmsTypeOptions = [
    new DropdownOption('Industry-based','Fondée sur l’industrie', 'industry-based'),
    new DropdownOption('Organization-specific', 'Spécifique à l’organisation', 'organization-specific'),
    new DropdownOption('National/International Management System Standard', 'Norme nationale/internationale de système de gestion', 'international-management-system-standard')
  ]

  //Industry Standard Options
  static industryStandardOptions =[
    new DropdownOption('ISO 45001:2018: Occupational health and safety management systems-Requirements with guidance for use','ISO 45001:2018 : Systèmes de management de la santé et de la sécurité au travail - Exigences et lignes directrices pour leur utilisation', 'ISO 45001:2018'),
    new DropdownOption('CSA Z45001-19: Occupational health and safety management systems-Requirements with guidance for use','CSA Z45001-19 : Systèmes de management de la santé et de la sécurité au travail - Exigences et lignes directrices pour leur utilisation', 'CSA Z45001-19'),
    new DropdownOption('IHSA COR™ 2020-IHSA Certificate of Recognition 2020-Health and Safety Management System-Standard','CDRMC IHSA 2020-Certificat de reconnaissance de l’IHSA 2020 – Norme et système de gestion de la santé et de la sécurité', 'IHSA COR 2020'),
    new DropdownOption('Responsible Care®-RC14001','Gestion responsable MD-RC14001', 'RC14001:2015'),
    new DropdownOption('Responsible Care®-RCMS','Gestion responsable MD RCMS', 'RCMS:2019')
 ];

  public static getLanguageCodeBySectionName(sectionName: string, secondHalfOfSubstring: boolean = false) {
    switch (sectionName) {
      case this.ProofOfMaterialPurchase:
        return "ApplicationForNewTrainingProgram.TPMaterial.ProofofPurchaseProgram"
      case this.ProgramDocumentsDesk:
        return "ApplicationForNewTrainingProgram.ProgramDocumentsDesk"
      case this.LessonPlan:
        return "ApplicationForNewTrainingProgram.LessonPlan"
      case this.InstructorManual:
        return "ApplicationForNewTrainingProgram.InstructorManual"
      case this.PresentationMaterial:
        return "ApplicationForNewTrainingProgram.PresentationMaterials"
      case this.ParticipantManual:
        return "ApplicationForNewTrainingProgram.ParticipantManual"
      case this.AssociateHandouts:
        return "ApplicationForNewTrainingProgram.AssociatedHandouts"
      case this.QuickReferenceMaterial:
        return "ApplicationForNewTrainingProgram.QuickReferenceMaterialsforLearners"
      case this.EquipmentList:
        return "ApplicationForNewTrainingProgram.EquipmentLists"
      case this.LearnerEvaluationPlan:
        return "ApplicationForNewTrainingProgram.LearnerEvaluationPlan"
      case this.WrittenTestsAndAssements:
        return "ApplicationForNewTrainingProgram.WrittenTestsandAssessmentDocuments"
      case this.QualityAssuranceAndContinuousImprovementsPlan:
        return "ApplicationForNewTrainingProgram.QualityAssuranceandContinuousImprovementPlan"
      case this.DetailedDesignDocument:
        return "ApplicationForNewTrainingProgram.DetailedDesignDocument"
      case this.StoryBoard:
        return "ApplicationForNewTrainingProgram.StoryBoard"
      case this.ELearningCourse:
        return "ApplicationForNewTrainingProgram.ELearningCourse"
      case this.ProofOfTrainingCompletionDocument:
        return "ApplicationForNewTrainingProgram.ProofofTrainingCompletionDocument"
      case this.AttestationCertification:
        return "ApplicationForNewTrainingProgram.AttestationProgramAppReview.ConsentHeader"
      case this.TrainingProviderAttestation:
        return "ApplicationForNewTrainingProgram.TrainingProviderAttestation"
      case this.TrainingProgramAttestation:
        return "ApplicationForNewTrainingProgram.TPAttestation.TrainingProgramAttestation"
      case this.ApplicantInformation:
        return "ProgramDetails.ApprovedApplicationSubTabs.ApplicantInformation"
      case this.ProgramRequirements:
        return "ProgramDetails.ApprovedApplicationSubTabs.ProgramRequirements"
      case this.ProgramStandards:
        return "ProgramDetails.ApprovedApplicationSubTabs.ProgramStandards"
      default:
        if (sectionName.indexOf('|') > 0)
          return sectionName.split('|')[secondHalfOfSubstring ? 1 : 0]
          //return sectionName.split('|')[0]
        else
          return ''
    }
  }

  public static getLanguageCodeByPageName(pageName: string): string {
    switch (pageName) {
      case this.ApplicantInformation:
        return 'ProgramDetails.ApprovedApplicationSubTabs.ApplicantInformation';
      case this.Attestations:
        return 'ProgramDetails.ApprovedApplicationSubTabs.Attestations';
      case this.ProgramDocuments:
        return 'ProgramDetails.ApprovedApplicationSubTabs.ProgramMaterial';
      case this.ProgramRequirements:
        return 'ProgramDetails.ApprovedApplicationSubTabs.ProgramRequirements'
      case this.ProgramStandards:
        return 'ProgramDetails.ApprovedApplicationSubTabs.ProgramStandards'
      case this.ProviderStandards:
        return 'ProgramDetails.ApprovedApplicationSubTabs.ProviderStandards'
      default:
        return '';
    }
  }

  public static getCourseRequestTypeText(reqType: string): string {
    switch (reqType.toString()) {
      case '1':
        return 'ClassEnrolment.SingleEnrolment';
      case '2':
        return 'ClassEnrolment.MultipleEnrolments';
      default:
        return '';
    }
  }
  public static getCourseRequestForText(reqType: string, reqFor: string): string {
    if (reqType.toString() === '1') {
      switch (reqFor.toString()) {
        case '1':
          return 'ClassEnrolment.Myself';
        case '2':
          return 'ClassEnrolment.TeamMember';
        default:
          return '';
      }
    }
    else {
      switch (reqFor.toString()) {
        case '1':
          return 'ClassEnrolment.MyselfAndTeamMembers';
        case '2':
          return 'ClassEnrolment.TeamMembers';
        default:
          return '';
      }
    }
  }

  public static getPhaseNameByPhaseId(index: number | undefined) {
    if (index == undefined) return '';
    switch (index) {
      case 1:
        return 'Triage';
      case 2:
        return 'Desk';
      case 3:
        return 'Field';
      case 4:
        return 'Recommendation';
      case 5:
        return 'Approved';
      case 6:
        return 'Archived';
      default:
        return '';
    }
  }

  public static getTriageStatusByIndex(index: number | undefined) {
    if (index == undefined) return ''
    switch (index) {
      case 1:
        return 'Triage.NotSubmitted'
      case 2:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:
      case 19:
      case 20:
      case 21:
      case 22:
      case 23:
      case 24:
      case 25:
      case 27:
      case 28:
        return 'Triage.UnderReview'
      case 3:
      case 40:
      case this.ProactiveChangesSubmitted:
      case this.ProgramUpdatesSubmitted:
      case this.ProQAReviewInProgress:
      case this.ProQADapIssued:
      case this.ReviewInProgress:
      case this.ProgramUpdatesAcknowledged:
      case this.ProActiveFieldChecklistToBeCompleted:
      case this.ProActiveFieldChecklistSubmitted:
      case this.ProactivePrefieldChecklistConcernIssued:
      case this.ProactivePrefieldChecklistAcknowledged:
      case this.QAFieldVisitToBeScheduled:
      case this.QAFieldVisitScheduleProposalSubmitted:
      case this.ProactiveFieldAssessmentScheduled:
      case this.ProactiveFieldAssessmentTSAProposed:
      case this.ProactiveFieldAssessmentTPConfirmed:
      case this.ProactiveFieldAssessmentConductedByTSA:
      case this.ChangeRequestApproved:
      case this.TrainingDeliveryVisitStart:
      case this.DAPResponsesAcknowledged:
      case this.TrainingDeliveryChecklistSubmitted:
      case this.DapIssuedForFieldAssessment:
      case this.DapRespondedForFieldAssessment:
      case this.DapResponsesAcknowledgedForFieldAssessment:
      case this.TrainingProgramApproved:
      case this.ProactiveFieldRecommendationReportRevisedByTsa:
      case this.ReactiveProgramQAStartedByComplaint:
        return 'Triage.CPOApproved'
      case this.ProactiveChangesSubmitted:
      case this.ProgramUpdatesSubmitted:
        return 'Triage.ProactiveChange'
      case this.RejectedDuringTriage:
      case this.RejectedDuringDesk:
      case this.RejectedDuringField:
      case this.RejectedDuringRecommendation:
      case 36:
      case 37:
      case 38:
      case 39:
      case 41:
      case 42:
      case this.ChangeRequestLeadsToProgramRevoked:
        return 'Triage.Inactive'
    }
    return ''
  }

  public static getPurchaseProgramPrefixByProgramId(programId: string): string {
    switch (programId) {
      case this.WAHFull:
        return 'WAH'
      case this.JHSC1:
        return 'JHSC-2014-1'
      case this.JHSC2:
        return 'JHSC-2014-2'
      case this.JHSCR:
        return 'JHSC-2014-R'
    }
    return '';
  }

  public static getDeliveryMethodOrderByDeliveryMethodId(deliveryMethodId: string): number {
    switch (deliveryMethodId) {
      case this.InClass:
        return 1
      case this.Distance:
        return 2
      case this.Blended:
        return 3
      case this.eLearning:
      default:
        return 4
    }
  }

  static isNullOrEmpty(input: any): boolean {
    if (input === null || input === '' || input === undefined || (input !== null && (input.toString().toLowerCase() === 'null' || input.toString().toLowerCase() === 'undefined'))) {
      return true;
    }
    return false;
  }

  static replaceExtraCharacters(str: string) {
    return (str ?? '').replace(/[\s~`!@#$%^&*()_+\-={[}\]|\\:;"'<,>.?/]+/g, '_').toLowerCase();
  }

  public static hasValidReferenceLink(referenceLink, fileUploads: FileUploadComponent[]): boolean {
    if (fileUploads == null || fileUploads.length == 0) return true;
    if (!referenceLink || referenceLink.indexOf("/") == -1) return false
    let referenceSplit: string[] = referenceLink.split("/")

    let relevantSection = fileUploads.filter(x => x.sectionName == referenceSplit[0])
    if (relevantSection == null || relevantSection.length == 0) return false

    let file = relevantSection[0].uploadedDocList.filter(x => x.fileName == referenceSplit.slice(1).join("/"))
    if (file == null || file.length == 0) return false

    else return true
  }

  public static getPageNameBySectionName(sectionName: string) {
    switch (sectionName) {
      case this.ApplicantInformation:
      case this.ApplicationInfoSectionName:
        return this.ApplicantInformation
      case this.TrainingProviderAttestation:
      case this.TrainingProgramAttestation:
      case this.AttestationCertification:
        return this.Attestations
      case this.LessonPlan:
      case this.InstructorManual:
      case this.PresentationMaterial:
      case this.ParticipantManual:
      case this.AssociateHandouts:
      case this.QuickReferenceMaterial:
      case this.EquipmentList:
      case this.LearnerEvaluationPlan:
      case this.WrittenTestsAndAssements:
      case this.DetailedDesignDocument:
      case this.StoryBoard:
      case this.ELearningCourse:
      case this.QualityAssuranceAndContinuousImprovementsPlan:
      case this.ProofOfTrainingCompletionDocument:
      case this.ProgramDocumentsDesk:
        return this.ProgramDocuments
      case this.ProgramRequirements:
        return this.ProgramRequirements
      case this.ProgramStandards:
        return this.ProgramStandards
      default:
        if (sectionName && sectionName.indexOf('|') > 0)
          return this.ProgramRequirements
        else
          return ""
    }
  }

  public static getDeskPhaseInDays(model: TrainingProgramApplicationProcessInfoModel) {
    if (model.DeskStartedDate && model.DeskCompletedDate) {
      let diffInMs = Math.abs(Number(new Date(model.DeskCompletedDate)) - Number(new Date(model.DeskStartedDate)));
      return Math.round(diffInMs / (1000 * 60 * 60 * 24));
    }
    else
      return 0;
  }

  public static getSectionTitle(isWAH: boolean, section: TrainingProgramAttestationSection, currentLang: string) {
    if (!isWAH && section.TitleJHSC != null && section.TitleJHSC != '') return currentLang == 'en' ? section.TitleJHSC : section.TitleJHSCFr
    return currentLang == 'en' ? section.Title : section.TitleFr
  }

  public static getPhaseIdFromTriageStatus(statusName: string) {
    let phaseId = 1;
    switch (statusName.toLowerCase()) {
      case 'triage':
        phaseId = this.TriagePhase;
        break;
      case 'desk':
        phaseId = this.DeskPhase;
        break;
      case 'field':
        phaseId = this.PreFieldPhase;
        break;
      case 'recommendation':
        phaseId = this.RecommendationPhase;
        break;
      default:
        break;
    }
    return phaseId;
  }

  public static getValueOrNA(value: string) {
    if (this.isNullOrEmpty(value))
      return 'General.NA'
    else return value;
  }

  public static getMyUtcDate(dateInput: Date) {
    return Date.UTC(new Date(dateInput).getUTCFullYear(), new Date(dateInput).getUTCMonth(), new Date(dateInput).getUTCDate());
  }

  public static Base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var arrayBuffer = new ArrayBuffer(binaryString.length);
    var bytes = new Uint8Array(arrayBuffer);
    for (var i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i);
    return bytes.buffer;
  }

  public static getSoseStatusByStatusId(index: number | undefined) {
    if (index == undefined) return ''
    switch (index) {
      default:
      case 1:
        return 'EmployerPortal.Sose.Incomplete'
      case 2:
      case 3:
        return 'EmployerPortal.Sose.UnderReview'
      case 4:
        return 'EmployerPortal.Sose.Active'
      case 5:
        return 'EmployerPortal.Sose.Inactive'
    }
  }

  public static getSoseStatusByStatusGuid(status: string) {
    switch (status.toLowerCase()) {
      default:
      case TrainingProgramApplicationUtils.SoseApplicationStatusIncompleteId.toLowerCase():
        return 'EmployerPortal.Sose.Incomplete'
      case TrainingProgramApplicationUtils.SoseAppSubmittedForMinistryReviewId.toLowerCase():
      case TrainingProgramApplicationUtils.SoseAppSubmittedReviewCompletedId.toLowerCase():
        return 'EmployerPortal.Sose.UnderReview'
      case TrainingProgramApplicationUtils.SoseAppApprovedByMnistryId.toLowerCase():
        return 'EmployerPortal.Sose.Active'
      case TrainingProgramApplicationUtils.SoseAppRejectedByMnistryId.toLowerCase():
        return 'EmployerPortal.Sose.Inactive'
    }
  }

  public static getSoseHeaderStatusByStatusId(index: number | undefined) {
    if (index == undefined) return ''
    switch (index) {
      default:
      case 1:
        return 'EmployerPortal.Sose.Incomplete'
      case 2:
      case 3:
        return 'EmployerPortal.Sose.ApplicationReview'
      case 4:
        return 'EmployerPortal.Sose.Active'
      case 5:
        return 'EmployerPortal.Sose.Inactive'
    }
  }

  public static getSoseHeaderStatusByStatusGuid(status: string) {
    switch (status.toLowerCase()) {
      default:
      case TrainingProgramApplicationUtils.SoseApplicationStatusIncompleteId.toLowerCase():
        return 'EmployerPortal.Sose.Incomplete'
      case TrainingProgramApplicationUtils.SoseAppSubmittedForMinistryReviewId.toLowerCase():
      case TrainingProgramApplicationUtils.SoseAppSubmittedReviewCompletedId.toLowerCase():
        return 'EmployerPortal.Sose.ApplicationReview'
      case TrainingProgramApplicationUtils.SoseAppApprovedByMnistryId.toLowerCase():
        return 'EmployerPortal.Sose.Active'
      case TrainingProgramApplicationUtils.SoseAppRejectedByMnistryId.toLowerCase():
        return 'EmployerPortal.Sose.Inactive'
    }
  }

  public static getSoseActionTitleByStatusGuid(status: string) {
    switch (status.toLowerCase()) {
      default:
      case TrainingProgramApplicationUtils.SoseApplicationStatusIncompleteId.toLowerCase():
        return 'EmployerPortal.Sose.ApplicationCreatedOn'
      case TrainingProgramApplicationUtils.SoseAppSubmittedForMinistryReviewId.toLowerCase():
      case TrainingProgramApplicationUtils.SoseAppSubmittedReviewCompletedId.toLowerCase():
        return 'EmployerPortal.Sose.ApplicationSubmittedOn'
      case TrainingProgramApplicationUtils.SoseAppApprovedByMnistryId.toLowerCase():
        return 'EmployerPortal.Sose.RecognitionAsOf'
      case TrainingProgramApplicationUtils.SoseAppRejectedByMnistryId.toLowerCase():
        return 'EmployerPortal.Sose.RecognitionInactiveAsOf'
    }
  }

}
